export default __webpack_public_path__ + "static/media/banner-01.4ff717e5.jpg";